import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { X } from "lucide-react";

/**
 * Sticky bulk-action bar that floats above a table when 1+ rows are selected.
 * Pass `actions` as an array of { key, label, icon, onClick, variant }.
 */
export default function BulkActionsBar({ selectedCount, onClear, actions = [] }) {
  if (selectedCount === 0) return null;
  return (
    <div
      data-testid="bulk-actions-bar"
      className="sticky top-3 z-20 flex items-center gap-2 rounded-md border bg-slate-900 text-white px-3 py-2 shadow-md"
    >
      <Badge className="bg-white text-slate-900 hover:bg-white" data-testid="bulk-sel-count">
        {selectedCount} selected
      </Badge>
      {actions.map((a) => (
        <Button
          key={a.key}
          size="sm"
          variant={a.variant || "secondary"}
          onClick={a.onClick}
          data-testid={`bulk-action-${a.key}`}
        >
          {a.icon ? <a.icon className="h-3.5 w-3.5 mr-1.5" /> : null}
          {a.label}
        </Button>
      ))}
      <Button
        size="icon" variant="ghost"
        className="text-white hover:bg-slate-800 ml-auto"
        onClick={onClear}
        data-testid="bulk-clear"
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
}
